import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { AuthService } from './../../../../../../../services/API/auth/auth.service';
import { UsersService } from './../../../../../../../services/API/users/users.service';
import { ScalesService } from './../../../../../../../services/API/scales/scales.service';

@Component({
    selector: 'app-edit-user',
    templateUrl: './edit-user.component.html',
    styleUrls: ['./edit-user.component.css'],
    standalone: false
})
export class EditUserComponent implements OnInit {

  form: UntypedFormGroup;

  id: number;
  name: string;
  surname: string;
  email: string;
  //rol: string;
  active: string;
  permiso_total: boolean = false;
  permiso_pesar: boolean = false;
  permiso_clasificar: boolean = false;
  permiso_registros: boolean = false;
  permiso_registrosDatos: boolean = false;
  permiso_registrosPesos: boolean = false;
  permiso_usuarios: boolean = false;
  permiso_contenedores: boolean = false;
  permiso_contenedores_alta_movimientos: boolean = false;
  permiso_contenedores_alta_mantenimientos: boolean = false;

  allScales: any[] = [];
  selectedScaleIds = new Set<number>();
  scalesLoading = false;
  scalesError: string = '';

  constructor(
    private fb: UntypedFormBuilder,
    public authService: AuthService,
    private usersService: UsersService,
    private scalesService: ScalesService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditUserComponent>
  ) { }

  ngOnInit(): void {
    this.id = parseInt(String(this.data['id'] ?? '0'), 10) || 0;
    this.name = this.data['name'];
    this.surname = this.data['surname'];
    this.email = this.data['email'];
    this.permiso_total = (this.data['permiso_total'] === 'true');
    this.permiso_pesar = (this.data['permiso_pesar'] === 'true');
    this.permiso_clasificar = (this.data['permiso_clasificar'] === 'true');
    this.permiso_registros = (this.data['permiso_registros'] === 'true');
    this.permiso_registrosDatos = (this.data['permiso_registrosDatos'] === 'true');
    this.permiso_registrosPesos = (this.data['permiso_registrosPesos'] === 'true');
    this.permiso_usuarios = (this.data['permiso_usuarios'] === 'true');
    this.permiso_contenedores = (this.data['permiso_contenedores'] === 'true');
    this.permiso_contenedores_alta_movimientos = (this.data['permiso_contenedores_alta_movimientos'] === 'true');
    this.permiso_contenedores_alta_mantenimientos = (this.data['permiso_contenedores_alta_mantenimientos'] === 'true');
    //this.rol = this.data['rol'];
    this.active = this.data['active'];
    this.form = this.fb.group({
      name: [this.name, [Validators.required, Validators.minLength(1), Validators.maxLength(255)]],
      surname: [this.surname, [Validators.required, Validators.minLength(1), Validators.maxLength(255)]],
      email: [this.email, [Validators.required, Validators.minLength(1), Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.+[a-zA-Z]{2,4}$")]],
      active: [this.active, Validators.required],
    });
    //rol: [this.rol, Validators.required],

    if (this.permiso_pesar) {
      this.loadScales();
    }
  }

  userRolCheck(permission: string){
    return this.authService.userRolCheck(permission);
  }

  onPermisoPesarToggle(): void {
    if (this.permiso_pesar) {
      this.loadScales();
    } else {
      this.selectedScaleIds.clear();
    }
  }

  private loadScales(): void {
    if (!this.id) {
      return;
    }
    this.scalesLoading = true;
    this.scalesError = '';
    this.scalesService.getScales('true').subscribe({
      next: (scales: any) => {
        this.allScales = Array.isArray(scales) ? scales : [];
        this.usersService.getUsuarioScales(this.id).subscribe({
          next: (ids: any) => {
            this.selectedScaleIds.clear();
            if (Array.isArray(ids)) {
              ids.forEach((v) => this.selectedScaleIds.add(parseInt(String(v), 10)));
            }
            this.scalesLoading = false;
          },
          error: () => {
            this.scalesError = 'No se pudieron cargar las básculas asignadas al usuario.';
            this.scalesLoading = false;
          }
        });
      },
      error: () => {
        this.scalesError = 'No se pudieron cargar las básculas activas (revise sesión/permisos).';
        this.allScales = [];
        this.scalesLoading = false;
      }
    });
  }

  isScaleSelected(id: number): boolean {
    return this.selectedScaleIds.has(id);
  }

  toggleScale(id: number, checked: boolean): void {
    const n = parseInt(String(id), 10);
    if (!n) return;
    if (checked) {
      this.selectedScaleIds.add(n);
    } else {
      this.selectedScaleIds.delete(n);
    }
  }

  save() {
    const {value, valid} = this.form;
    if(valid){
      var data = [{
        'name': value["name"],
        'surname': value["surname"],
        'email': value["email"],
        'active': value["active"],
        'permiso_total': this.permiso_total,
        'permiso_pesar': this.permiso_pesar,
        'permiso_clasificar': this.permiso_clasificar,
        'permiso_registros': this.permiso_registros,
        'permiso_registrosDatos': this.permiso_registrosDatos,
        'permiso_registrosPesos': this.permiso_registrosPesos,
        'permiso_usuarios': this.permiso_usuarios,
        'permiso_contenedores': this.permiso_contenedores,
        'permiso_contenedores_alta_movimientos': this.permiso_contenedores_alta_movimientos,
        'permiso_contenedores_alta_mantenimientos': this.permiso_contenedores_alta_mantenimientos,
        'scale_ids': this.permiso_pesar ? Array.from(this.selectedScaleIds.values()) : [],
      }];
      this.dialogRef.close(data);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
